import { UserOutlined } from "@ant-design/icons";
import { Avatar, notification } from "antd";
import { DOCTOR_PREFIX_PATH } from "configs/AppConfig";


const NOTIFICATION_PLACEMENTS = new Set([
  "topLeft",
  "topRight",
  "bottomLeft",
  "bottomRight",
  "top",
  "bottom",
  "left",
  "right",
]);

export const ShowNotification = (
  type,
  colorOrPlacement,
  placementOrBodyMessage,
  bodyMessageOrAvatarUrl,
  avatarUrlOrHistory,
  historyOrShouldShowIcon,
  shouldShowIcon = true
) => {
      const hasExplicitColor = !NOTIFICATION_PLACEMENTS.has(colorOrPlacement);
      const color = hasExplicitColor ? colorOrPlacement : undefined;
      const placement = hasExplicitColor ? placementOrBodyMessage : colorOrPlacement;
      const BodyMessage = hasExplicitColor ? bodyMessageOrAvatarUrl : placementOrBodyMessage;
      const avatarUrl = hasExplicitColor ? avatarUrlOrHistory : bodyMessageOrAvatarUrl;
      const history = hasExplicitColor ? historyOrShouldShowIcon : avatarUrlOrHistory;
      const effectiveShouldShowIcon =
            typeof historyOrShouldShowIcon === "boolean" && hasExplicitColor
              ? historyOrShouldShowIcon
              : typeof shouldShowIcon === "boolean"
                ? shouldShowIcon
                : true;

      notification[type]({
         placement : placement,
         message : "Message",
         //description: BodyMessage
         description: (
            <div style={color ? { color } : undefined}>
                  {avatarUrl ? 
                        <div onClick={() => history.push(`${DOCTOR_PREFIX_PATH}/chat-room`)} style={{cursor: 'pointer', position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px', right: '5%', minWidth: 'fit-content'}}>
                              <Avatar src={avatarUrl} style={{ width: '50px', height: '50px', flexShrink: 0 }} />
                              <div style={{wordBreak: 'break-all'}}>{BodyMessage}</div>   
                        </div> 
                        : 
                        BodyMessage
                  }
                  
            </div>
         ),
            icon: (
                  effectiveShouldShowIcon ? 
            <Avatar src={"https://www.gravatar.com/avatar/icldev@gmail.com"} icon={<UserOutlined />} /> : null // Custom avatar with fallback icon
          ) ,
        })
  }
